module.exports = __webpack_public_path__ + "img/phone_home_slide.58f5a46d.jpg";